import { Box, Chip } from '@mui/material';
import { useMaterialUIController } from 'context';
import { LeadResponse } from '../../services/responses/lead.response';
import { getCrmColors } from '../../crm-theme';
import { StatusChipSize, statusChipSx, statusDotSx } from './crm-lead-status-chip.styles';

interface Props {
    lead: LeadResponse;
    size: StatusChipSize;
    /// Sem ele o chip só mostra; com ele abre o menu de status preso ao chip.
    onOpenMenu?: (anchor: HTMLElement) => void;
}

/// Pílula do status do lead, igual no card e na lista.
export const CrmLeadStatusChip = ({ lead, size, onOpenMenu }: Props) => {
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    return (
        <Chip
            icon={<Box sx={statusDotSx(lead.statusColor, size)} />}
            label={lead.statusName}
            size="small"
            // O chip fica dentro do card e da linha, que abrem o lead: o clique para aqui.
            onClick={onOpenMenu
                ? (e) => { e.stopPropagation(); onOpenMenu(e.currentTarget); }
                : undefined}
            sx={statusChipSx(cc, lead.statusColor, size, Boolean(onOpenMenu))}
        />
    );
};
